import { CompanyResponse } from './company.model';

export interface PassBusinessResponse {
    id: number;
    pass: string;
    company: number;
    type: number;
    typeName: string;
}

export interface PassBusinessGroupedResponse {
    company: CompanyResponse;
    passes: PassBusinessResponse[];
}

export class PassBusinessRequest {
    id: number = null;
    company: number = null;
    type: number = null;
    pass: string = '';
}

export interface PassBusinessTypeResponse {
    value: number;
    name: string;
}

export const PASS_BUSINESS_TYPES: PassBusinessTypeResponse[] = [
    { value: 1, name: 'SAT' },
    { value: 2, name: 'MINISTERIO' },
    { value: 3, name: 'IGSS' }
];

export interface PassBusinessCompanyView extends PassBusinessGroupedResponse {
    expanded?: boolean;
}

export interface PassBusinessItemView extends PassBusinessResponse {
    visible?: boolean;
    deleting?: boolean;
}